import axios from "axios";
import buildUrl from "build-url-ts";

const apiUrl = process.env.REACT_APP_API_URL;
const accountApi = `${apiUrl}/api/2.0/accounts`;

export const accountsApi = {
  fetchAccount: async (): Promise<any> => {
    const url = buildUrl(accountApi);

    const response = await axios.get(url);
    const data = response.data;
    return data;
  },

  updateAccount: async (data: any): Promise<any> => {
    const url = buildUrl(accountApi);
    const response = await axios.put(url, data);
    return response.data;
  },
};